/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Grid } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import InputForm from "../../../../../../components/InputForm";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import store from "../../../../../../store/store";
import Loading from "../../../../../home/components/Loading";
import FormActions from "../../../../components/FormActions";
import styles from "./styles.module.scss";

export const ProcessualForm = (props) => {
  let api = AppAPIService.getInstance();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [documentCategoryOptions, setDocumentCategoryOptions] = useState([]);
  const { auth } = store.getState();

  const [action, setAction] = useState("");
  const [actionRole, setActionRole] = useState("ok");
  const [actionError, setActionError] = useState("");

  const handleInputAction = (action) => {
    if (!action) {
      setAction();
      setActionError("Campo obrigatório");
      setActionRole("notOk");
    } else {
      setAction(action);
      setActionError("");
      setActionRole("ok");
    }
  };

  /* documentCategory */
  const [documentCategory, setDocumentCategory] = useState([]);
  const [documentCategoryRole, setDocumentCategoryRole] = useState("");
  const [documentCategoryError, setDocumentCategoryError] = useState("");

  const handleInputDocumentCategory = (documentCategory) => {
    if (!documentCategory) {
      setDocumentCategory([]);
      setDocumentCategoryError("Campo obrigatório");
      setDocumentCategoryRole("notOk");
    } else {
      setDocumentCategory(documentCategory);
      setDocumentCategoryError("");
      setDocumentCategoryRole("ok");
    }
  };

  /* end documentCategory */

  /* observation */
  const [observation, setObservation] = useState();
  const [observationError, setObservationError] = useState("");
  const [observationRole, setObservationRole] = useState("ok");

  const handleInputObservation = (observation) => {
    if (!observation) {
      setObservation();
      setObservationError("");
      setObservationRole("ok");
    } else {
      setObservation(observation);
      setObservationError("");
      setObservationRole("ok");
    }
  };

  /* end category type */

  const getDocumentCategoryOptions = useCallback(async () => {
    try {
      setIsLoading(true);
      const params = {
        filters: {
          typeName: "especifico",
        },
        perPage: 1000,
      }
      const response = await api.makeHttpRequest({
        url: `/document-category/list-paginated`,
        params,
        method: "GET",
      });
      const processClasses = Array.isArray(response?.data) ? response.data : response || [];
      const processClassOptionsFromApi = processClasses.map(
        (processClass) => {
          return { value: processClass.id, label: processClass.name };
        }
      );
      setDocumentCategoryOptions(processClassOptionsFromApi);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [api]);

  useEffect(() => {
    getDocumentCategoryOptions();
  }, [getDocumentCategoryOptions]);
  /* end category type */

  const formIsValid = useCallback(() => {
    let validForm = true;

    validForm =
      documentCategory.length > 0 &&
      documentCategoryRole === "ok" &&
      action !== "" &&
      actionRole === "ok";
      return validForm;
  }, [
    documentCategory,
    documentCategoryRole,
    actionRole,
    action,
  ]);
  /* end form validation */

  const submitCreation = useCallback(
    async (e) => {
      setIsLoading(true);
      e.preventDefault();
      try {
        let data = {
          action: action?.label ? action.label : action,
          fields: documentCategory.map((res) => {
            return { documentCategoryId: res };
          }),
          observation,
        };
        const response = await api.makeHttpRequest({
          url: "/action",
          method: "POST",
          data,
        });
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: `Ação criada com sucesso.`,
        }).then(() => {
          history.push("/admin/parametrizacao");
        });
      } catch (error) {
        setIsLoading(false);
        let reason = "";
        if (error?.response?.data?.reason.includes("ER_DUP_ENTRY")) {
          reason = "Já existe uma ação com esse nome";
        }
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `Houve um erro ao criar a ação! ${reason}`,
        });
      } finally {
        setIsLoading(false);
      }
    },
    [
      history,
      api,
      auth.token,
      auth.user,
      action,
      documentCategory,
      observation,
      setIsLoading,
    ]
  );
  /* end submitCreation */

  /* submitEdition */
  const submitEdition = useCallback(
    async (e) => {
      setIsLoading(true);
      e.preventDefault();
      try {
        const response = await api.makeHttpRequest({
          url: `/action/${props.editingRecord.id}`,
          method: "PUT",
          data: {
            fields: documentCategory.map((res) => {
              return { documentCategoryId: res };
            }),
            observation,
            action: action,
          },
        });
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: `Ação atualizada com sucesso`,
        }).then(() => {
          history.push("/admin/parametrizacao");
        });
      } catch (error) {
        setIsLoading(false);
        let reason = "";
        if (error?.response?.data?.reason.includes("ER_DUP_ENTRY")) {
          reason = "Já existe uma ação com esse nome";
        }
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Houve um erro ao atualizar a ação! ${reason}`,
        });

      } finally {
        setIsLoading(false);
      }
    },
    [
      history,
      api,
      auth.token,
      auth.user,
      documentCategory,
      observation,
      action,
      setIsLoading,
    ]
  );

  /* clean form */
  const onCleanForm = async () => {
    setDocumentCategory([]);
    setDocumentCategoryError("");
    setDocumentCategoryRole("");
    setObservation("");
    setObservationError("");
    setObservationRole("");
  };
  useEffect(() => {
    if (props?.editingRecord) {
      const { editingRecord } = props;
      handleInputDocumentCategory(
        editingRecord.fields.map((field) => {
          return field.documentCategory.id
        })
      );
      handleInputObservation(editingRecord.observation);
      handleInputAction(editingRecord?.action);
    }
  }, [props?.editingRecord]);

  /* end clean form */
  return (
    <Container
      style={{
        display: "block",
        margin: "0",
        padding: "0",
      }}
      maxWidth="xl"
    >
      <Loading isLoading={isLoading} />
      <Container
        style={{
          width: "100%",
          display: "block",
          padding: 0,
          margin: "0 !important",
        }}
        maxWidth="xl"
      >
        <form
          className={styles.form}
          autoComplete="off"
          style={{
            padding: "0 !important",
            margin: "0 !important",
          }}
        >
          <div
            className={styles.containerInputs}
            style={{
              padding: "0 !important",
            }}
          >
            <Grid container style={{}}>
            <Grid
                md={12}
                container
                style={{
                  marginTop: "29px",
                }}
              >
                <InputForm
                  type="text"
                  name="action"
                  placeholder="Descreva a ação"
                  label={"Ação *"}
                  value={action}
                  onChange={handleInputAction}
                  error={actionError}
                  role={actionRole}
                />
              </Grid>
              <Grid
                md={12}
                style={{
                  marginTop: "29px",
                }}
              >
                <InputForm
                  isMulti
                  isSelectV2
                  placeholder="Selecione os documentos obrigatórios"
                  label="Documentos Obrigatórios *"
                  value={documentCategory}
                  options={documentCategoryOptions}
                  required={true}
                  onChange={handleInputDocumentCategory}
                  error={documentCategoryError}
                  role={documentCategoryRole}
                  maxWidth="100%"
                />
              </Grid>
              <Grid
                md={12}
                container
                style={{
                  marginTop: "29px",
                }}
              >
                <InputForm
                  type="text"
                  name="observation"
                  placeholder="Digite as observações, se necessário"
                  label={"Observações"}
                  value={observation}
                  onChange={handleInputObservation}
                  error={observationError}
                  role={observationRole}
                />
              </Grid>
            </Grid>
          </div>
        </form>
      </Container>
      <FormActions
        module={"parametrizacao"}
        formIsValid={formIsValid()}
        onCleanForm={onCleanForm}
        onSubmit={props?.editingRecord ? submitEdition : submitCreation}
        hideCancel={true}
        messagem
      />
    </Container>
  );
};
export default ProcessualForm;
